module.exports = __webpack_public_path__ + "img/js.b91dd58b.svg";